<template>
  <v-container class="text-center fill-height background">
    <v-row justify="center" align="center">
      <v-col
        v-for="(button, index) in buttons"
        :key="index"
        cols="12"
        md="6"
        class="d-flex flex-column"
      >
        <v-btn
          dark
          rounded
          class="font-weight-bold text-h5"
          min-height="80"
          :color="button.color"
          @click="navigate(button.type)"
        >
          {{ button.label }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      buttons: [
        { type: 'check-in-out', label: '簽到簽退', color: '#000957' },
        { type: 'vitalsign', label: '生理數據', color: '#344CB7' },
        { type: 'daily-record', label: '照護日誌', color: '#577BC1' },
      ],
    }
  },
  methods: {
    navigate(type) {
      this.$router.push(`/m/cases/${type}`)
    },
  },
}
</script>
<style>
.background {
  background-color: #e2e2e2;
}
</style>
